// extracted by mini-css-extract-plugin
export default {"slider":"Main_slider__AVLhd","content":"Main_content__SDbP2","slider_title":"Main_slider_title__7KWX5"};